import { ReactElement } from 'react';

import { useGraphQLQuery } from '@betterment/js-runtime';

import { SidebarBenefitsAndRewardsDocument } from './graphql/query.sidebarBenefitsAndRewards.generated';

import { Nav } from '../../../Shared/components-v2/nav/Nav';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { ListShimmer } from '../ListShimmer';
import { NavLink } from '../nav-link/NavLink';

export const BenefitsAndRewardsNav = () => {
  const { data } = useGraphQLQuery(SidebarBenefitsAndRewardsDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) return <ListShimmer />;

  const { isEarnedRewardsEligible, isEligibleRewardsEligible, premiumOnboardingOption, employers } = data;

  const shouldShowRewardsLink = isEarnedRewardsEligible || isEligibleRewardsEligible;
  const hasPremiumOnboardingOption = !!premiumOnboardingOption;
  const hasEmployeeBenefits = !!employers?.length;

  const links: { key: string; element: ReactElement }[] = [];

  if (hasEmployeeBenefits) {
    links.push({
      key: 'employee-benefits',
      element: (
        <NavLink to="/employee_benefits/active_benefits">
          <NavLink.Icon name="CharityHand" />
          <NavLink.Text>Employee benefits</NavLink.Text>
        </NavLink>
      ),
    });
  }

  if (hasPremiumOnboardingOption) {
    links.push({
      key: 'advice-initiation',
      element: (
        <NavLink to="/advice_initiation" reloadDocument={true}>
          <NavLink.Icon name="Person" />
          <NavLink.Text>Talk to an advisor</NavLink.Text>
        </NavLink>
      ),
    });
  }

  if (shouldShowRewardsLink) {
    links.push({
      key: 'earn-rewards',
      element: (
        <NavLink to={data?.isEligibleRewardsEligible ? urlBuilder.appRewards() : urlBuilder.appEarnedRewards()}>
          <NavLink.Icon name="Present" />
          <NavLink.Text>Earn rewards</NavLink.Text>
        </NavLink>
      ),
    });
  }

  const hasAtLeastOneLink = !!links.length;
  const hasAtLeastTwoLinks = links.length > 1;

  if (!hasAtLeastOneLink) return null;

  return (
    <>
      <Nav.Separator />
      <Nav aria-label="Benefits and rewards">
        {hasAtLeastTwoLinks ? (
          <Nav.List>
            {links.map(link => (
              <Nav.ListItem key={link.key}>{link.element}</Nav.ListItem>
            ))}
          </Nav.List>
        ) : (
          links[0].element
        )}
      </Nav>
    </>
  );
};
